// Get airline
export const GET_AIRLINE_REQUEST = 'GET_AIRLINE_REQUEST'
export const GET_AIRLINE_SUCCESS = 'GET_AIRLINE_SUCCESS'
export const GET_AIRLINE_FAIL = 'GET_AIRLINE_REQUEST'
